const ProfessionalTemplate = ({ candidateData }) => {
    if (!candidateData) return null

    const {
        name,
        email,
        phone,
        basic_details,
        employment,
        education,
        projects,
        certifications,
        it_skills,
        candidate_languages,
    } = candidateData

    return (
        <div className="resume-professional w-[210mm] min-h-[297mm] max-w-[210mm] mx-auto bg-white text-gray-800 font-sans leading-tight relative box-border overflow-hidden">
            {/* Header */}
            <div className="bg-blue-700 text-white py-6 px-8">
                <div className="grid grid-cols-3 gap-6">
                    <div className="col-span-2">
                        <h1 className="text-left text-3xl font-bold tracking-tight mb-1">{name}</h1>
                        <p className="text-lg text-blue-100 mb-4">{employment?.[0]?.job_title?.title || "Professional"}</p>
                        {basic_details?.profile_summery && (
                            <p className="text-sm text-white max-w-[95%] leading-relaxed">{basic_details.profile_summery}</p>
                        )}
                    </div>
                    <div className="col-span-1">
                        <div className="flex flex-col space-y-3">
                            <div className="flex items-center space-x-3">
                                <div className="w-7 h-7 bg-blue-600 rounded-full flex items-center justify-center">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                        />
                                    </svg>
                                </div>
                                <span className="text-sm">{phone}</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <div className="w-7 h-7 bg-blue-600 rounded-full flex items-center justify-center">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div>
                                <span className="text-sm">{email}</span>
                            </div>
                            <div className="flex items-start space-x-3">
                                <div className="w-7 h-7 bg-blue-600 rounded-full flex items-center justify-center mt-0.5">
                                    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                </div>
                                <div className="text-sm">
                                    {basic_details?.address && `${basic_details.address}, `}
                                    {basic_details?.city?.name}, {basic_details?.state?.name}
                                    <br />
                                    {basic_details?.country?.name} {basic_details?.pincode}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-0">
                {/* Main Content */}
                <div className="col-span-2 p-8 border-r border-gray-200">
                    {/* Work Experience */}
                    {employment && employment.length > 0 && (
                        <div className="mb-8">
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Professional Experience
                            </h2>
                            <div className="space-y-6">
                                {employment.map((job, index) => (
                                    <div key={index}>
                                        <div className="flex justify-between mb-2">
                                            <h3 className="text-base font-bold text-blue-600">{job.job_title?.title}</h3>
                                            <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full font-medium">
                                                {job.start_month}/{job.start_year} -{" "}
                                                {job.end_month ? `${job.end_month}/${job.end_year}` : "Present"}
                                            </span>
                                        </div>
                                        <div className="flex justify-between mb-3">
                                            <p className="font-semibold text-base">{job.current_company}</p>
                                            <span className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded">
                                                {job.employement_type}
                                            </span>
                                        </div>
                                        <p className="text-sm mb-2 leading-relaxed">{job.job_profile}</p>
                                        <p className="text-xs text-gray-600">Department: {job.department?.title}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Projects */}
                    {projects && projects.length > 0 && (
                        <div className="mb-8">
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Key Projects
                            </h2>
                            <div className="space-y-6">
                                {projects.map((project, index) => (
                                    <div key={index}>
                                        <div className="flex justify-between mb-2">
                                            <h3 className="text-base font-bold text-blue-600">{project.project_tag}</h3>
                                            <span
                                                className={`text-sm px-3 py-1 rounded-full font-medium ${project.project_status === "Ongoing"
                                                    ? "bg-green-100 text-green-800"
                                                    : "bg-blue-100 text-blue-800"
                                                    }`}
                                            >
                                                {project.project_status}
                                            </span>
                                        </div>
                                        <p className="text-sm mb-3 leading-relaxed">{project.project_description}</p>
                                        <div className="grid grid-cols-2 gap-4 text-xs text-gray-600">
                                            <div>
                                                <p className="font-semibold mb-1">Role: {project.role}</p>
                                                <p>Team Size: {project.team_size}</p>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Education */}
                    {education && education.length > 0 && (
                        <div>
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Education
                            </h2>
                            <div className="space-y-5">
                                {education.map((edu, index) => (
                                    <div key={index}>
                                        <div className="flex justify-between mb-2">
                                            <h3 className="text-base font-bold text-blue-600">{edu.education_course?.title}</h3>
                                            <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-full font-medium">
                                                {edu.course_duration_start_year} - {edu.course_duration_end_year}
                                            </span>
                                        </div>
                                        <p className="font-semibold mb-2">{edu.insitute_university}</p>
                                        <div className="grid grid-cols-2 gap-4 text-sm">
                                            {edu.education_course_specialty && (
                                                <p>
                                                    <span className="font-medium">Specialization:</span> {edu.education_course_specialty.title}
                                                </p>
                                            )}
                                            <p>
                                                <span className="font-medium">{edu.grading_system}:</span> {edu.marks}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Sidebar */}
                <div className="col-span-1 p-8 bg-gray-50">
                    {/* Skills */}
                    {it_skills && it_skills.length > 0 && (
                        <div className="mb-8">
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Technical Skills
                            </h2>
                            <div className="space-y-4">
                                {it_skills.map((skill, index) => (
                                    <div key={index}>
                                        <div className="flex justify-between mb-1">
                                            <p className="font-semibold text-sm">{skill.skill.title}</p>
                                            <p className="text-xs text-gray-600">{skill.versions && `v${skill.versions}`}</p>
                                        </div>
                                        <div className="w-full h-3 bg-gray-200 rounded-full mb-1">
                                            <div
                                                className="h-3 bg-blue-500 rounded-full"
                                                style={{
                                                    width: `${Math.min(100, (skill.experience_year * 12 + skill.experience_month) / 0.6)}%`,
                                                }}
                                            />
                                        </div>
                                        <p className="text-xs text-right">
                                            {skill.experience_year} years {skill.experience_month} months
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Certifications */}
                    {certifications && certifications.length > 0 && (
                        <div className="mb-8">
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Certifications
                            </h2>
                            <div className="space-y-2">
                                {certifications.map((cert, index) => (
                                    <div key={index} className="flex items-start">
                                        <div>
                                            <p className="font-semibold text-sm flex items-center">
                                                <svg
                                                    className="h-4 w-4 text-blue-500 mr-2 mt-1 flex-shrink-0"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                    />
                                                </svg>
                                                {cert.certification_name}
                                            </p>
                                            <div className="text-xs text-gray-600 mt-1 ml-6 space-y-1">
                                                {cert.certification_number && (
                                                    <div>
                                                        <span className="font-medium">ID:</span> {cert.certification_number}
                                                    </div>
                                                )}
                                                {cert.certification_date && (
                                                    <div>
                                                        <span className="font-medium">Issued:</span> {cert.certification_date}
                                                    </div>
                                                )}
                                                {cert.certification_validity && (
                                                    <div>
                                                        <span className="font-medium">Valid until:</span> {cert.certification_validity}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Languages */}
                    {candidate_languages && candidate_languages.length > 0 && (
                        <div>
                            <h2 className="text-base font-bold text-blue-700 mb-4 pb-2 border-b-2 border-blue-700 uppercase tracking-wider">
                                Languages
                            </h2>
                            <div className="grid grid-cols-2 gap-4">
                                {candidate_languages.map((lang, index) => {
                                    const proficiency = getLanguageProficiency(lang)
                                    return (
                                        <div key={index} className="bg-white p-3 rounded-md shadow-sm">
                                            <p className="font-semibold mb-1 text-sm">{lang.language}</p>
                                            <p className="text-xs text-gray-600 mb-2">{proficiency}</p>
                                            <div className="w-full h-2 bg-gray-200 rounded-full">
                                                <div
                                                    className="h-2 bg-blue-400 rounded-full"
                                                    style={{ width: getProficiencyPercentage(proficiency) }}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

// Helper function to format language proficiency
const getLanguageProficiency = (lang) => {
    const abilities = []
    if (lang.can_read) abilities.push("Read")
    if (lang.can_write) abilities.push("Write")
    if (lang.can_speak) abilities.push("Speak")

    if (abilities.length === 3) return "Fluent"
    if (abilities.length === 2) return "Intermediate"
    if (abilities.length === 1) return "Basic"
    return "None"
}

// Helper function to get percentage width for proficiency bar
const getProficiencyPercentage = (proficiency) => {
    switch (proficiency) {
        case "Fluent":
            return "100%"
        case "Intermediate":
            return "70%"
        case "Basic":
            return "40%"
        default:
            return "10%"
    }
}

export default ProfessionalTemplate
